import { render, staticRenderFns } from "./SkillDialogHeader.vue?vue&type=template&id=e06515a6&scoped=true"
import script from "./SkillDialogHeader.vue?vue&type=script&lang=js"
export * from "./SkillDialogHeader.vue?vue&type=script&lang=js"
import style0 from "./SkillDialogHeader.vue?vue&type=style&index=0&id=e06515a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e06515a6",
  null
  
)

export default component.exports